export const FirebaseConfig = {
	"projectId": "urbaapp",
	"appId": "1:887194964445:web:0ca9c3fab277f335dca634",
	"databaseURL": "https://urbaapp-default-rtdb.firebaseio.com",
	"storageBucket": "urbaapp.firebasestorage.app",
	"apiKey": "AIzaSyCd_rGXgj7GcKdfCsvrKOdzgp1ZCzbVWSc",
	"authDomain": "urbaapp-2d272.firebaseapp.com",
	"messagingSenderId": "887194964445",
	"measurementId": "G-VEGHNN4XW2"
};